import { MenuOutlined, SearchOutlined } from '@ant-design/icons';
import { Input, Select } from 'antd';
import React, { useCallback, useMemo } from 'react';
import { debounce } from 'es-toolkit';
import { SEARCH_DEBOUNCE_DELAY } from '@ui/features/Calculations/constants';

const DataTableSortOptions = [
    { label: 'Sort by', value: '', disabled: true },
    { label: 'Name A-Z', value: 'name/asc' },
    { label: 'Name Z-A', value: 'name/desc' },
    { label: 'Age ↑', value: 'age/asc' },
    { label: 'Age ↓', value: 'age/desc' },
];

interface PatientListFilterGroupProps {
    title: React.ReactNode;
    filter?: string;
    setFilter?: (filter: string) => void;
    smartFilterButton?: React.ReactNode;
    onSearch?: (search: string) => void;
    onOrderChange?: (orderBy: string, orderDirection: 'asc' | 'desc') => void;
    isSearchEnabled?: boolean;
}

export default function PatientListFilterGroup({
    title,
    smartFilterButton,
    onSearch,
    isSearchEnabled = true,
}: PatientListFilterGroupProps) {
    // Debounced search handler for backend
    const handleSearchChange = useMemo(
        () =>
            debounce((value: string) => {
                onSearch?.(value);
            }, SEARCH_DEBOUNCE_DELAY),
        [onSearch]
    );

    // Handle search input change
    const handleSearchInputChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value;
            handleSearchChange(value);
        },
        [handleSearchChange]
    );

    return (
        <div className="flex items-center justify-between">
            {title}
            <div className="flex items-center gap-3">
                {smartFilterButton}

                {isSearchEnabled && (
                    <Input
                        prefix={<SearchOutlined className="text-[#8C8C8C]" />}
                        placeholder="Search..."
                        onChange={handleSearchInputChange}
                        className="w-[200px] rounded-[6px] text-[14px]"
                        allowClear
                        data-testid="patients-search-input"
                    />
                )}
            </div>
        </div>
    );
}
